import { createContext } from 'react';

const AudienceContext = createContext();

export default AudienceContext;
